export enum WEEKDAYS {
    Monday = 'Monday',
    Tuesday = 'Tuesday',
    Wednesday = 'Wednesday',
    Thursday = 'Thursday',
    Friday = 'Friday',
    Saturday = 'Saturday',
    Sunday = 'Sunday',
}

export const WeekdayAbbreviations: { [key in WEEKDAYS]: string } = {
    [WEEKDAYS.Monday]: 'Mo',
    [WEEKDAYS.Tuesday]: 'Tu',
    [WEEKDAYS.Wednesday]: 'We',
    [WEEKDAYS.Thursday]: 'Th',
    [WEEKDAYS.Friday]: 'Fr',
    [WEEKDAYS.Saturday]: 'Sa',
    [WEEKDAYS.Sunday]: 'Su',
};

export interface TimingSlotsModel {
    id: string;
    day_of_week: WEEKDAYS;
    start_time: string;
    end_time: string;
}

export interface TimingSlotBlock {
    day?: string;
    time?: string;
}
